module.exports = __webpack_public_path__ + "media/10_9.8a97d560.wav";